import { useMediaQueries } from '@react-hook/media-query'

import type { ChildrenProps } from '../DefaultElementProps'
import { context } from './context'

type Props = ChildrenProps & {
	queries: Record<string, string>
}

export const MediaQueryProvider = ({ children, queries }: Props) => {
	const result = useMediaQueries(queries)

	return <context.Provider value={result.matches}>{children}</context.Provider>
}
